/* eslint-disable */
/**
 * Vendored build of @web-eid/web-eid-library v2.1.0 (https://github.com/web-eid/web-eid.js), MIT licensed.
 * The library is published only on the GitLab npm registry and ships modern ES syntax that our
 * Babel 6 / webpack 2 toolchain cannot parse, so it is committed here pre-transpiled to ES5.
 * Regenerate with: npx @babel/cli --presets @babel/preset-env --plugins @babel/plugin-transform-runtime dist/es/web-eid.js
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VersionMismatchError = exports.VersionInvalidError = exports.UserTimeoutError = exports.UserCancelledError = exports.UnknownError = exports.NativeUnavailableError = exports.NativeFatalError = exports.ExtensionUnavailableError = exports.ErrorCode = exports.DeveloperError = exports.ContextInsecureError = exports.ActionTimeoutError = exports.Action = void 0;
exports.authenticate = authenticate;
exports.config = void 0;
exports.getSigningCertificate = getSigningCertificate;
exports.sign = sign;
exports.status = status;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));
var _templateObject, _templateObject2, _templateObject3, _errorCodeToErrorClas;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = (0, _getPrototypeOf2.default)(derived);
  return (0, _possibleConstructorReturn2.default)(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], (0, _getPrototypeOf2.default)(_this).constructor) : derived.apply(_this, args));
}
/**
 * MIT License
 *
 * Copyright (c) 2020-2025 Estonian Information System Authority
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

var Action;
(function (Action) {
  Action["WARNING"] = "web-eid:warning";
  Action["STATUS"] = "web-eid:status";
  Action["STATUS_ACK"] = "web-eid:status-ack";
  Action["STATUS_SUCCESS"] = "web-eid:status-success";
  Action["STATUS_FAILURE"] = "web-eid:status-failure";
  Action["AUTHENTICATE"] = "web-eid:authenticate";
  Action["AUTHENTICATE_ACK"] = "web-eid:authenticate-ack";
  Action["AUTHENTICATE_SUCCESS"] = "web-eid:authenticate-success";
  Action["AUTHENTICATE_FAILURE"] = "web-eid:authenticate-failure";
  Action["GET_SIGNING_CERTIFICATE"] = "web-eid:get-signing-certificate";
  Action["GET_SIGNING_CERTIFICATE_ACK"] = "web-eid:get-signing-certificate-ack";
  Action["GET_SIGNING_CERTIFICATE_SUCCESS"] = "web-eid:get-signing-certificate-success";
  Action["GET_SIGNING_CERTIFICATE_FAILURE"] = "web-eid:get-signing-certificate-failure";
  Action["SIGN"] = "web-eid:sign";
  Action["SIGN_ACK"] = "web-eid:sign-ack";
  Action["SIGN_SUCCESS"] = "web-eid:sign-success";
  Action["SIGN_FAILURE"] = "web-eid:sign-failure";
})(Action || (Action = {}));
var Action$1 = exports.Action = Action;
var ErrorCode;
(function (ErrorCode) {
  ErrorCode["ERR_WEBEID_ACTION_TIMEOUT"] = "ERR_WEBEID_ACTION_TIMEOUT";
  ErrorCode["ERR_WEBEID_USER_TIMEOUT"] = "ERR_WEBEID_USER_TIMEOUT";
  ErrorCode["ERR_WEBEID_VERSION_MISMATCH"] = "ERR_WEBEID_VERSION_MISMATCH";
  ErrorCode["ERR_WEBEID_VERSION_INVALID"] = "ERR_WEBEID_VERSION_INVALID";
  ErrorCode["ERR_WEBEID_EXTENSION_UNAVAILABLE"] = "ERR_WEBEID_EXTENSION_UNAVAILABLE";
  ErrorCode["ERR_WEBEID_NATIVE_UNAVAILABLE"] = "ERR_WEBEID_NATIVE_UNAVAILABLE";
  ErrorCode["ERR_WEBEID_UNKNOWN_ERROR"] = "ERR_WEBEID_UNKNOWN_ERROR";
  ErrorCode["ERR_WEBEID_CONTEXT_INSECURE"] = "ERR_WEBEID_CONTEXT_INSECURE";
  ErrorCode["ERR_WEBEID_USER_CANCELLED"] = "ERR_WEBEID_USER_CANCELLED";
  ErrorCode["ERR_WEBEID_NATIVE_INVALID_ARGUMENT"] = "ERR_WEBEID_NATIVE_INVALID_ARGUMENT";
  ErrorCode["ERR_WEBEID_NATIVE_FATAL"] = "ERR_WEBEID_NATIVE_FATAL";
  ErrorCode["ERR_WEBEID_ACTION_PENDING"] = "ERR_WEBEID_ACTION_PENDING";
  ErrorCode["ERR_WEBEID_MISSING_PARAMETER"] = "ERR_WEBEID_MISSING_PARAMETER";
})(ErrorCode || (ErrorCode = {}));
var ErrorCode$1 = exports.ErrorCode = ErrorCode;
var DeveloperError = exports.DeveloperError = /*#__PURE__*/function (_Error) {
  function DeveloperError(message) {
    (0, _classCallCheck2.default)(this, DeveloperError);
    return _callSuper(this, DeveloperError, [message]);
  }
  (0, _inherits2.default)(DeveloperError, _Error);
  return (0, _createClass2.default)(DeveloperError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
var MissingParameterError = /*#__PURE__*/function (_DeveloperError) {
  function MissingParameterError(message) {
    var _this2;
    (0, _classCallCheck2.default)(this, MissingParameterError);
    _this2 = _callSuper(this, MissingParameterError, [message]);
    _this2.name = _this2.constructor.name;
    _this2.code = ErrorCode$1.ERR_WEBEID_MISSING_PARAMETER;
    return _this2;
  }
  (0, _inherits2.default)(MissingParameterError, _DeveloperError);
  return (0, _createClass2.default)(MissingParameterError);
}(DeveloperError);
var ActionTimeoutError = exports.ActionTimeoutError = /*#__PURE__*/function (_Error2) {
  function ActionTimeoutError() {
    var _this3;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "extension message timeout";
    (0, _classCallCheck2.default)(this, ActionTimeoutError);
    _this3 = _callSuper(this, ActionTimeoutError, [message]);
    _this3.name = _this3.constructor.name;
    _this3.code = ErrorCode$1.ERR_WEBEID_ACTION_TIMEOUT;
    return _this3;
  }
  (0, _inherits2.default)(ActionTimeoutError, _Error2);
  return (0, _createClass2.default)(ActionTimeoutError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
var SECURE_CONTEXTS_INFO_URL = "https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts";
var ContextInsecureError = exports.ContextInsecureError = /*#__PURE__*/function (_Error3) {
  function ContextInsecureError() {
    var _this4;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Secure context required, see " + SECURE_CONTEXTS_INFO_URL;
    (0, _classCallCheck2.default)(this, ContextInsecureError);
    _this4 = _callSuper(this, ContextInsecureError, [message]);
    _this4.name = _this4.constructor.name;
    _this4.code = ErrorCode$1.ERR_WEBEID_CONTEXT_INSECURE;
    return _this4;
  }
  (0, _inherits2.default)(ContextInsecureError, _Error3);
  return (0, _createClass2.default)(ContextInsecureError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
var ExtensionUnavailableError = exports.ExtensionUnavailableError = /*#__PURE__*/function (_Error4) {
  function ExtensionUnavailableError() {
    var _this5;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Web-eID extension is not available";
    (0, _classCallCheck2.default)(this, ExtensionUnavailableError);
    _this5 = _callSuper(this, ExtensionUnavailableError, [message]);
    _this5.name = _this5.constructor.name;
    _this5.code = ErrorCode$1.ERR_WEBEID_EXTENSION_UNAVAILABLE;
    return _this5;
  }
  (0, _inherits2.default)(ExtensionUnavailableError, _Error4);
  return (0, _createClass2.default)(ExtensionUnavailableError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
var NativeFatalError = exports.NativeFatalError = /*#__PURE__*/function (_Error5) {
  function NativeFatalError() {
    var _this6;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "native application terminated with a fatal error";
    (0, _classCallCheck2.default)(this, NativeFatalError);
    _this6 = _callSuper(this, NativeFatalError, [message]);
    _this6.name = _this6.constructor.name;
    _this6.code = ErrorCode$1.ERR_WEBEID_NATIVE_FATAL;
    return _this6;
  }
  (0, _inherits2.default)(NativeFatalError, _Error5);
  return (0, _createClass2.default)(NativeFatalError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
var NativeUnavailableError = exports.NativeUnavailableError = /*#__PURE__*/function (_Error6) {
  function NativeUnavailableError() {
    var _this7;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Web-eID native application is not available";
    (0, _classCallCheck2.default)(this, NativeUnavailableError);
    _this7 = _callSuper(this, NativeUnavailableError, [message]);
    _this7.name = _this7.constructor.name;
    _this7.code = ErrorCode$1.ERR_WEBEID_NATIVE_UNAVAILABLE;
    return _this7;
  }
  (0, _inherits2.default)(NativeUnavailableError, _Error6);
  return (0, _createClass2.default)(NativeUnavailableError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
var UnknownError = exports.UnknownError = /*#__PURE__*/function (_Error7) {
  function UnknownError() {
    var _this8;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "an unknown error occurred";
    (0, _classCallCheck2.default)(this, UnknownError);
    _this8 = _callSuper(this, UnknownError, [message]);
    _this8.name = _this8.constructor.name;
    _this8.code = ErrorCode$1.ERR_WEBEID_UNKNOWN_ERROR;
    return _this8;
  }
  (0, _inherits2.default)(UnknownError, _Error7);
  return (0, _createClass2.default)(UnknownError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
var UserCancelledError = exports.UserCancelledError = /*#__PURE__*/function (_Error8) {
  function UserCancelledError() {
    var _this9;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "request was cancelled by the user";
    (0, _classCallCheck2.default)(this, UserCancelledError);
    _this9 = _callSuper(this, UserCancelledError, [message]);
    _this9.name = _this9.constructor.name;
    _this9.code = ErrorCode$1.ERR_WEBEID_USER_CANCELLED;
    return _this9;
  }
  (0, _inherits2.default)(UserCancelledError, _Error8);
  return (0, _createClass2.default)(UserCancelledError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
var UserTimeoutError = exports.UserTimeoutError = /*#__PURE__*/function (_Error9) {
  function UserTimeoutError() {
    var _this10;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "user failed to respond in time";
    (0, _classCallCheck2.default)(this, UserTimeoutError);
    _this10 = _callSuper(this, UserTimeoutError, [message]);
    _this10.name = _this10.constructor.name;
    _this10.code = ErrorCode$1.ERR_WEBEID_USER_TIMEOUT;
    return _this10;
  }
  (0, _inherits2.default)(UserTimeoutError, _Error9);
  return (0, _createClass2.default)(UserTimeoutError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
var VersionInvalidError = exports.VersionInvalidError = /*#__PURE__*/function (_Error10) {
  function VersionInvalidError() {
    var _this11;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "invalid version string";
    (0, _classCallCheck2.default)(this, VersionInvalidError);
    _this11 = _callSuper(this, VersionInvalidError, [message]);
    _this11.name = _this11.constructor.name;
    _this11.code = ErrorCode$1.ERR_WEBEID_VERSION_INVALID;
    return _this11;
  }
  (0, _inherits2.default)(VersionInvalidError, _Error10);
  return (0, _createClass2.default)(VersionInvalidError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
function tmpl(strings, requiresUpdate) {
  return "Update required for Web-eID ".concat(requiresUpdate);
}
var VersionMismatchError = exports.VersionMismatchError = /*#__PURE__*/function (_Error11) {
  function VersionMismatchError(message, versions, requiresUpdate) {
    var _this12;
    (0, _classCallCheck2.default)(this, VersionMismatchError);
    if (!message) {
      if (!requiresUpdate) {
        message = "requiresUpdate not provided";
      } else if (requiresUpdate.extension && requiresUpdate.nativeApp) {
        message = tmpl(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["", ""])), "extension and native app");
      } else if (requiresUpdate.extension) {
        message = tmpl(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["", ""])), "extension");
      } else if (requiresUpdate.nativeApp) {
        message = tmpl(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["", ""])), "native app");
      }
    }
    _this12 = _callSuper(this, VersionMismatchError, [message]);
    _this12.name = _this12.constructor.name;
    _this12.code = ErrorCode$1.ERR_WEBEID_VERSION_MISMATCH;
    _this12.requiresUpdate = requiresUpdate !== null && requiresUpdate !== void 0 ? requiresUpdate : {
      nativeApp: false,
      extension: false
    };
    if (versions) {
      var library = versions.library,
        extension = versions.extension,
        nativeApp = versions.nativeApp;
      Object.assign(_this12, {
        library: library,
        extension: extension,
        nativeApp: nativeApp
      });
    }
    return _this12;
  }
  (0, _inherits2.default)(VersionMismatchError, _Error11);
  return (0, _createClass2.default)(VersionMismatchError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
var ActionPendingError = /*#__PURE__*/function (_DeveloperError2) {
  function ActionPendingError() {
    var _this13;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "same action for Web-eID browser extension is already pending";
    (0, _classCallCheck2.default)(this, ActionPendingError);
    _this13 = _callSuper(this, ActionPendingError, [message]);
    _this13.name = _this13.constructor.name;
    _this13.code = ErrorCode$1.ERR_WEBEID_ACTION_PENDING;
    return _this13;
  }
  (0, _inherits2.default)(ActionPendingError, _DeveloperError2);
  return (0, _createClass2.default)(ActionPendingError);
}(DeveloperError);
var config = exports.config = Object.freeze({
  VERSION: "2.1.0",
  EXTENSION_HANDSHAKE_TIMEOUT: 1000,
  NATIVE_APP_HANDSHAKE_TIMEOUT: 5 * 1000,
  DEFAULT_USER_INTERACTION_TIMEOUT: 2 * 60 * 1000,
  MAX_EXTENSION_LOAD_DELAY: 1000
});
var NativeInvalidArgumentError = /*#__PURE__*/function (_DeveloperError3) {
  function NativeInvalidArgumentError() {
    var _this14;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "native application received an invalid argument";
    (0, _classCallCheck2.default)(this, NativeInvalidArgumentError);
    _this14 = _callSuper(this, NativeInvalidArgumentError, [message]);
    _this14.name = _this14.constructor.name;
    _this14.code = ErrorCode$1.ERR_WEBEID_NATIVE_INVALID_ARGUMENT;
    return _this14;
  }
  (0, _inherits2.default)(NativeInvalidArgumentError, _DeveloperError3);
  return (0, _createClass2.default)(NativeInvalidArgumentError);
}(DeveloperError);
var errorCodeToErrorClass = (_errorCodeToErrorClas = {}, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_errorCodeToErrorClas, ErrorCode$1.ERR_WEBEID_ACTION_PENDING, ActionPendingError), ErrorCode$1.ERR_WEBEID_ACTION_TIMEOUT, ActionTimeoutError), ErrorCode$1.ERR_WEBEID_CONTEXT_INSECURE, ContextInsecureError), ErrorCode$1.ERR_WEBEID_EXTENSION_UNAVAILABLE, ExtensionUnavailableError), ErrorCode$1.ERR_WEBEID_MISSING_PARAMETER, MissingParameterError), ErrorCode$1.ERR_WEBEID_NATIVE_INVALID_ARGUMENT, NativeInvalidArgumentError), ErrorCode$1.ERR_WEBEID_NATIVE_FATAL, NativeFatalError), ErrorCode$1.ERR_WEBEID_NATIVE_UNAVAILABLE, NativeUnavailableError), ErrorCode$1.ERR_WEBEID_USER_CANCELLED, UserCancelledError), ErrorCode$1.ERR_WEBEID_USER_TIMEOUT, UserTimeoutError), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_errorCodeToErrorClas, ErrorCode$1.ERR_WEBEID_VERSION_INVALID, VersionInvalidError), ErrorCode$1.ERR_WEBEID_VERSION_MISMATCH, VersionMismatchError), ErrorCode$1.ERR_WEBEID_UNKNOWN_ERROR, UnknownError));
function isSerializedError(obj) {
  if ((0, _typeof2.default)(obj) !== "object" || obj === null) {
    return false;
  }
  var errorObject = obj;
  return typeof errorObject.code === "string" && typeof errorObject.message === "string" && errorCodeToErrorClass[errorObject.code] != null;
}
function deserializeError(errorObject) {
  var error;
  if (isSerializedError(errorObject)) {
    var CustomError = errorCodeToErrorClass[errorObject.code];
    error = new CustomError();
    Object.entries(errorObject).forEach(function (_ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      Reflect.set(error, key, value);
    });
  } else {
    error = new UnknownError();
    var unknownObject = errorObject;
    if (unknownObject !== null && unknownObject !== void 0 && unknownObject.stack) error.stack = unknownObject.stack;
    if (unknownObject !== null && unknownObject !== void 0 && unknownObject.message) error.message = unknownObject.message;
  }
  return error;
}
var WebExtensionService = /*#__PURE__*/function () {
  function WebExtensionService() {
    var _this15 = this;
    (0, _classCallCheck2.default)(this, WebExtensionService);
    this.loggedWarnings = [];
    this.queue = [];
    window.addEventListener("message", function (event) {
      return _this15.receive(event);
    });
  }
  return (0, _createClass2.default)(WebExtensionService, [{
    key: "receive",
    value: function receive(event) {
      var _event$data,
        _this16 = this;
      if (typeof ((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.action) !== "string") return;
      if (!event.data.action.startsWith("web-eid:")) return;
      var message = event.data;
      var suffix = ["success", "failure", "ack"].find(function (s) {
        return message.action.endsWith(s);
      });
      var initialAction = this.getInitialAction(message.action);
      var pending = this.getPendingMessage(initialAction);
      if (message.action === Action$1.WARNING) {
        var _message$warnings;
        (_message$warnings = message.warnings) === null || _message$warnings === void 0 || _message$warnings.forEach(function (warning) {
          if (!_this16.loggedWarnings.includes(warning)) {
            _this16.loggedWarnings.push(warning);
            console.warn(warning.replace(/\n|\r/g, ""));
          }
        });
      } else if (pending) {
        switch (suffix) {
          case "ack":
            {
              clearTimeout(pending.ackTimer);
              break;
            }
          case "success":
            {
              var _pending$resolve;
              this.removeFromQueue(initialAction);
              (_pending$resolve = pending.resolve) === null || _pending$resolve === void 0 || _pending$resolve.call(pending, message);
              break;
            }
          case "failure":
            {
              var _pending$reject;
              var failureMessage = message;
              this.removeFromQueue(initialAction);
              (_pending$reject = pending.reject) === null || _pending$reject === void 0 || _pending$reject.call(pending, deserializeError(failureMessage.error));
              break;
            }
        }
      }
    }
  }, {
    key: "send",
    value: function send(message, timeout) {
      var _this17 = this;
      if (this.getPendingMessage(message.action)) {
        return Promise.reject(new ActionPendingError());
      } else if (!window.isSecureContext) {
        return Promise.reject(new ContextInsecureError());
      } else {
        var pending = {
          message: message
        };
        this.queue.push(pending);
        pending.promise = new Promise(function (resolve, reject) {
          pending.resolve = resolve;
          pending.reject = reject;
        });
        pending.ackTimer = window.setTimeout(function () {
          return _this17.onAckTimeout(pending);
        }, config.EXTENSION_HANDSHAKE_TIMEOUT);
        pending.replyTimer = window.setTimeout(function () {
          return _this17.onReplyTimeout(pending);
        }, timeout);
        window.postMessage(message, "*");
        return pending.promise;
      }
    }
  }, {
    key: "onReplyTimeout",
    value: function onReplyTimeout(pending) {
      var _pending$reject2;
      this.removeFromQueue(pending.message.action);
      (_pending$reject2 = pending.reject) === null || _pending$reject2 === void 0 || _pending$reject2.call(pending, new ActionTimeoutError());
    }
  }, {
    key: "onAckTimeout",
    value: function onAckTimeout(pending) {
      var _pending$reject3;
      clearTimeout(pending.replyTimer);
      this.removeFromQueue(pending.message.action);
      (_pending$reject3 = pending.reject) === null || _pending$reject3 === void 0 || _pending$reject3.call(pending, new ExtensionUnavailableError());
    }
  }, {
    key: "getPendingMessage",
    value: function getPendingMessage(action) {
      return this.queue.find(function (pm) {
        return pm.message.action === action;
      });
    }
  }, {
    key: "getInitialAction",
    value: function getInitialAction(action) {
      return action.replace(/-success$|-failure$|-ack$/, "");
    }
  }, {
    key: "removeFromQueue",
    value: function removeFromQueue(action) {
      var pending = this.getPendingMessage(action);
      clearTimeout(pending === null || pending === void 0 ? void 0 : pending.replyTimer);
      this.queue = this.queue.filter(function (pending) {
        return pending.message.action !== action;
      });
    }
  }]);
}();
/**
 * Sleeps for a specified time before resolving the returned promise.
 *
 * @param milliseconds Time in milliseconds until the promise is resolved
 *
 * @returns Empty promise
 */
function sleep(milliseconds) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      return resolve();
    }, milliseconds);
  });
}
var webExtensionService = new WebExtensionService();
var initializationTime = +new Date();
function extensionLoadDelay() {
  return _extensionLoadDelay.apply(this, arguments);
}
function _extensionLoadDelay() {
  _extensionLoadDelay = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var now;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          now = +new Date();
          _context.next = 3;
          return sleep(initializationTime + config.MAX_EXTENSION_LOAD_DELAY - now);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _extensionLoadDelay.apply(this, arguments);
}
function status() {
  return _status.apply(this, arguments);
}
function _status() {
  _status = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var timeout, message, _yield$webExtensionSe, library, extension, nativeApp;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return extensionLoadDelay();
        case 2:
          timeout = config.EXTENSION_HANDSHAKE_TIMEOUT + config.NATIVE_APP_HANDSHAKE_TIMEOUT;
          message = {
            action: Action$1.STATUS,
            libraryVersion: config.VERSION
          };
          _context2.prev = 4;
          _context2.next = 7;
          return webExtensionService.send(message, timeout);
        case 7:
          _yield$webExtensionSe = _context2.sent;
          library = _yield$webExtensionSe.library;
          extension = _yield$webExtensionSe.extension;
          nativeApp = _yield$webExtensionSe.nativeApp;
          return _context2.abrupt("return", {
            library: library,
            extension: extension,
            nativeApp: nativeApp
          });
        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2["catch"](4);
          if (_context2.t0 instanceof Error) {
            Reflect.set(_context2.t0, "library", config.VERSION);
          }
          throw _context2.t0;
        case 18:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[4, 14]]);
  }));
  return _status.apply(this, arguments);
}
function authenticate(_x, _x2) {
  return _authenticate.apply(this, arguments);
}
function _authenticate() {
  _authenticate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(challengeNonce, options) {
    var _options$userInteract;
    var timeout, message, _yield$webExtensionSe2, unverifiedCertificate, algorithm, signature, format, appVersion;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return extensionLoadDelay();
        case 2:
          if (challengeNonce) {
            _context3.next = 4;
            break;
          }
          throw new MissingParameterError("authenticate function requires a challengeNonce");
        case 4:
          timeout = config.EXTENSION_HANDSHAKE_TIMEOUT + config.NATIVE_APP_HANDSHAKE_TIMEOUT + ((_options$userInteract = options === null || options === void 0 ? void 0 : options.userInteractionTimeout) !== null && _options$userInteract !== void 0 ? _options$userInteract : config.DEFAULT_USER_INTERACTION_TIMEOUT);
          message = {
            action: Action$1.AUTHENTICATE,
            libraryVersion: config.VERSION,
            challengeNonce: challengeNonce,
            options: options
          };
          _context3.next = 8;
          return webExtensionService.send(message, timeout);
        case 8:
          _yield$webExtensionSe2 = _context3.sent;
          unverifiedCertificate = _yield$webExtensionSe2.unverifiedCertificate;
          algorithm = _yield$webExtensionSe2.algorithm;
          signature = _yield$webExtensionSe2.signature;
          format = _yield$webExtensionSe2.format;
          appVersion = _yield$webExtensionSe2.appVersion;
          return _context3.abrupt("return", {
            unverifiedCertificate: unverifiedCertificate,
            algorithm: algorithm,
            signature: signature,
            format: format,
            appVersion: appVersion
          });
        case 15:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _authenticate.apply(this, arguments);
}
function getSigningCertificate(_x3) {
  return _getSigningCertificate.apply(this, arguments);
}
function _getSigningCertificate() {
  _getSigningCertificate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(options) {
    var _options$userInteract2;
    var timeout, message, _yield$webExtensionSe3, certificate, supportedSignatureAlgorithms;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return extensionLoadDelay();
        case 2:
          timeout = config.EXTENSION_HANDSHAKE_TIMEOUT + config.NATIVE_APP_HANDSHAKE_TIMEOUT + ((_options$userInteract2 = options === null || options === void 0 ? void 0 : options.userInteractionTimeout) !== null && _options$userInteract2 !== void 0 ? _options$userInteract2 : config.DEFAULT_USER_INTERACTION_TIMEOUT) * 2;
          message = {
            action: Action$1.GET_SIGNING_CERTIFICATE,
            libraryVersion: config.VERSION,
            options: options
          };
          _context4.next = 6;
          return webExtensionService.send(message, timeout);
        case 6:
          _yield$webExtensionSe3 = _context4.sent;
          certificate = _yield$webExtensionSe3.certificate;
          supportedSignatureAlgorithms = _yield$webExtensionSe3.supportedSignatureAlgorithms;
          return _context4.abrupt("return", {
            certificate: certificate,
            supportedSignatureAlgorithms: supportedSignatureAlgorithms
          });
        case 10:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _getSigningCertificate.apply(this, arguments);
}
function sign(_x4, _x5, _x6, _x7) {
  return _sign.apply(this, arguments);
}
function _sign() {
  _sign = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(certificate, hash, hashFunction, options) {
    var _options$userInteract3;
    var timeout, message, _yield$webExtensionSe4, signature, signatureAlgorithm;
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return extensionLoadDelay();
        case 2:
          if (certificate) {
            _context5.next = 4;
            break;
          }
          throw new MissingParameterError("sign function requires a certificate as parameter");
        case 4:
          if (hash) {
            _context5.next = 6;
            break;
          }
          throw new MissingParameterError("sign function requires a hash as parameter");
        case 6:
          if (hashFunction) {
            _context5.next = 8;
            break;
          }
          throw new MissingParameterError("sign function requires a hashFunction as parameter");
        case 8:
          timeout = config.EXTENSION_HANDSHAKE_TIMEOUT + config.NATIVE_APP_HANDSHAKE_TIMEOUT + ((_options$userInteract3 = options === null || options === void 0 ? void 0 : options.userInteractionTimeout) !== null && _options$userInteract3 !== void 0 ? _options$userInteract3 : config.DEFAULT_USER_INTERACTION_TIMEOUT) * 2;
          message = {
            action: Action$1.SIGN,
            libraryVersion: config.VERSION,
            certificate: certificate,
            hash: hash,
            hashFunction: hashFunction,
            options: options
          };
          _context5.next = 12;
          return webExtensionService.send(message, timeout);
        case 12:
          _yield$webExtensionSe4 = _context5.sent;
          signature = _yield$webExtensionSe4.signature;
          signatureAlgorithm = _yield$webExtensionSe4.signatureAlgorithm;
          return _context5.abrupt("return", {
            signature: signature,
            signatureAlgorithm: signatureAlgorithm
          });
        case 16:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _sign.apply(this, arguments);
}


// WEBPACK FOOTER //
// ./src/vendor/web-eid.js